<template>
<div>
  <template>
    <arksnackbar v-model="statusval"></arksnackbar>
    <loader v-model=statusval.loading></loader>
  </template>

  <v-layout row wrap>
    <v-toolbar color="info" size="120px" dark>
      <v-toolbar-title class="baslikfont">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="toolbar"></slot>
      <v-menu bottom left v-if="menuitems != undefined">
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile v-for="(item, i) in menuitems" :key="i" @click="menuClick(i)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </v-layout>
  <v-container fluid>
    <slot></slot>
  </v-container>
</div>
</template>

<script>
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import tool from "../tools";

export default {
  props: ["title", "status", "menuitems"],
  components: {
    loader,
    arksnackbar,
  },
  data() {
    return {
      count: 0
    }
  },
  computed: {
    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      }
    }
  },
  mounted() {
    //this.$validator.localize('en', this.dictionary)
  },
  methods: {
    menuClick(index) {
      this.$emit("menuclick", index);
    }

  },

}
</script>
